export const LANGUAGE = {
  EN: 'English',
  KO: 'Korean',
};
